import { Badge, Dropdown, DropdownItem, DropdownSeparator } from './ui';
import { useWorkspace } from '../hooks';
import { useT } from '../i18n';

/**
 * Selector de contexto: Personal, Familiar o empresa.
 *
 * Es el mecanismo que hace multi-tenant a la interfaz. Quien no tenga
 * organización ve la invitación a Business en lugar de un menú con una sola
 * entrada, que no serviría de nada.
 */
export function WorkspaceSwitcher() {
  const { workspaces, active, switchTo } = useWorkspace();
  const t = useT();

  if (!active) return null;

  const esEmpresa = active.workspace.type === 'organization';

  return (
    <Dropdown
      label={t('workspace.switch')}
      align="left"
      trigger={() => (
        <span className="flex w-full items-center gap-2 rounded-xl border border-line/60 bg-surface-2/50 px-3 py-2 text-left transition hover:border-primary/50">
          <span className="grid h-7 w-7 shrink-0 place-items-center rounded-lg bg-brand text-xs font-semibold text-background">
            {esEmpresa ? '🏢' : '👤'}
          </span>
          <span className="min-w-0 flex-1">
            <span className="block truncate text-sm font-medium">{active.workspace.name}</span>
            <span className="block text-[11px] text-muted">
              {esEmpresa ? '29100 Business' : '29100 Personal'}
            </span>
          </span>
          <span aria-hidden="true" className="text-muted">
            ⌄
          </span>
        </span>
      )}
    >
      {({ close }) => (
        <>
          {workspaces.map(({ workspace, role }) => (
            <DropdownItem
              key={workspace.id}
              onClick={() => {
                switchTo(workspace.id);
                close();
              }}
            >
              <span className="min-w-0 flex-1 truncate">{workspace.name}</span>
              {workspace.id === active.workspace.id ? (
                <Badge tone="primary">{t('workspace.active')}</Badge>
              ) : null}
              {role !== 'OWNER' ? <span className="text-[11px] text-muted">{role}</span> : null}
            </DropdownItem>
          ))}

          {/* `role="separator"` sí es un hijo válido de un menú; un `div` no. */}
          <DropdownSeparator />
          <DropdownItem onClick={() => (window.location.href = '/onboarding')}>
            {workspaces.some((w) => w.workspace.type === 'organization')
              ? t('workspace.new')
              : t('workspace.exploreBusiness')}
          </DropdownItem>
        </>
      )}
    </Dropdown>
  );
}
